function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var ModTemplate = require('../../lib/templates/modtemplate');
var ArcadeMain = require('./lib/ui/main');
var SaitoHeader = require('./../../lib/saito/ui/saito-header/saito-header');
var InviteManager = require('./lib/ui/invites');
var Invite = require('./lib/ui/invite');
var GameWizard = require('./lib/ui/overlays/wizard');
var LoungeOverlay = require('./lib/ui/overlays/lounge');
var AddGameOverlay = require('./lib/ui/overlays/add-game');
var ArcadeGameInfo = require('./lib/ui/overlays/game-info');
var TeaserInstallOverlay = require('./lib/ui/overlays/teaser-install');
var SettingsOverlay = require('./lib/ui/settings_overlay');
var Game = require('./lib/game');
var Transaction = require('../../lib/saito/transaction')["default"];
var arcadeHome = require('./index');

/**
 * Arcade UI + invite/session controller.
 * Library titles are Game objects (lib/game.js) via addGame().
 * Invite records live in this.invites (see lib/invite-lifecycle.js).
 */
var Arcade = /*#__PURE__*/function (_ModTemplate) {
  function Arcade(app) {
    var _this;
    _classCallCheck(this, Arcade);
    _this = _callSuper(this, Arcade, [app]);
    _this.name = 'Arcade';
    _this.slug = 'arcade';
    _this.sudo = false;
    _this.description = 'Interface for creating and joining games coded for the Saito Open Source Game Engine.';
    _this.categories = 'Games Entertainment Appspace';
    _this.icon = 'fas fa-gamepad';
    _this.styles = ['/arcade/style.css'];
    _this.shortlinks_enabled = 1;
    _this.affix_callbacks_to = [];
    _this.services = [_this.app.network.createPeerService(null, 'arcade', '', 'saito')];

    // Library Game objects (displayed as Teasers).
    _this.games = [];
    // Active invite / session records.
    _this.invites = {};
    _this.main = null;
    _this.header = null;
    _this.show_splash = true;
    _this.lounge_overlay = null;
    _this.wizard_overlay = null;
    _this.add_game_overlay = null;
    _this.game_info_overlay = null;
    _this.teaser_install_overlay = null;
    _this.possibleHome = 1;
    _this.social = _this.buildSocial({
      twitter: '@SaitoOfficial',
      title: '🟥 Saito Arcade',
      url: '/arcade/',
      description: 'Peer to peer gaming on the blockchain',
      image: 'https://saito.tech/wp-content/uploads/2023/11/arcade-300x300.png'
    });
    app.connection.on('arcade-add-game', function () {
      if (_this.add_game_overlay) {
        _this.add_game_overlay.render();
      }
    });
    app.connection.on('arcade-notify-player-turn', function (game_id, target, status) {
      var _iterator = _createForOfIteratorHelper(app.options.games),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var game = _step.value;
          if (game.id == game_id) {
            game.status = status;
            game.target = target;
            app.storage.saveOptions();
            siteMessage("It is now your turn in ".concat(game.module), 5000);
            _this.renderInvites();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
    app.connection.on('arcade-gametable-addplayer', function (game_id) {
      var game_tx = _this.returnGameTransaction(game_id);
      if (game_tx) {
        _this.sendJoinTransaction({
          tx: game_tx,
          game_name: 'open_table'
        });
      }
    });
    app.connection.on('arcade-gametable-removeplayer', function (game_id, player_stats) {
      var game_tx = _this.returnGameTransaction(game_id);
      if (game_tx) {
        _this.sendLeaveTransaction(game_tx, player_stats);
      }
    });
    app.connection.on('arcade-game-ready-render-request', function (game_details) {
      _this._handleGameReadyNotification(game_details);
    });
    app.connection.on('arcade-continue-game-from-options', /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(game_mod) {
        var _game_mod$game;
        var id, game, game_tx, _newInvite, newInvite;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              id = (_game_mod$game = game_mod.game) === null || _game_mod$game === void 0 ? void 0 : _game_mod$game.id;
              if (id) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              game = _this.returnGame(id);
              if (game) {
                _context.n = 3;
                break;
              }
              _context.n = 2;
              return _this.createPseudoTransaction(game_mod.game);
            case 2:
              game_tx = _context.v;
              _this.addInviteRecord(game_tx, 'closed');
              _newInvite = new Invite(app, _this, null, 'short', game_tx, _this.publicKey);
              _this.render('lounge_overlay', {
                invite_data: _newInvite.invite_data
              });
              return _context.a(2);
            case 3:
              delete game.tx.msg.time_finished;
              delete game.tx.msg.method;
              delete game.tx.msg.winner;
              game.tx.msg.request = 'paused';
              newInvite = new Invite(app, _this, null, 'short', game.tx, _this.publicKey);
              _this.render('lounge_overlay', {
                invite_data: newInvite.invite_data
              });
            case 4:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    return _this;
  }

  /**
   * Create a Game and store it on this.games.
   * Modules supply data (and optional onClick) via respondTo('arcade-games');
   * Arcade owns the Game object.
   *
   * If game_data.name matches an existing Game, that entry is replaced
   * (supports modules that publish/update library titles after init).
   */
  _inherits(Arcade, _ModTemplate);
  return _createClass(Arcade, [{
    key: "addGame",
    value: function addGame() {
      var game_data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var game = new Game(this.app, this, game_data);
      if (game.name) {
        var idx = this.games.findIndex(function (g) {
          return g.name === game.name;
        });
        if (idx >= 0) {
          this.games[idx] = game;
          return game;
        }
        this.affix_callbacks_to.push(game.name);
      }
      this.games.push(game);
      return game;
    }

    /**
     * Remove a library Game by name. Used by modules that maintain dynamic
     * title lists (e.g. installed ROMs) without Arcade knowing their domain.
     */
  }, {
    key: "removeGame",
    value: function removeGame() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (!name) {
        return false;
      }
      var idx = this.games.findIndex(function (g) {
        return g.name === name;
      });
      if (idx < 0) {
        return false;
      }
      this.games.splice(idx, 1);
      this.affix_callbacks_to = this.affix_callbacks_to.filter(function (n) {
        return n !== name;
      });
      return true;
    }

    /**
     * Re-render library teasers if the Arcade UI is mounted.
     */
  }, {
    key: "renderGames",
    value: function renderGames() {
      var _this$main;
      if (!this.app.BROWSER) {
        return;
      }
      if ((_this$main = this.main) !== null && _this$main !== void 0 && _this$main.teasers) {
        this.main.teasers.render();
      }
    }
  }, {
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(app) {
        var _this2 = this;
        var league, _window, _iterator2, _step2, game, game_tx, _game_tx, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.n = 1;
              return _superPropGet(Arcade, "initialize", this, 3)([app]);
            case 1:
              this.games = [];
              this.affix_callbacks_to = [];

              // League attachment is browser UI only (teaser ranks / game-info).
              // League.respondTo('leagues-for-arcade') calls attachStyleSheets → document.
              league = null;
              if (app.BROWSER) {
                league = app.modules.returnFirstRespondTo('leagues-for-arcade');
              }
              app.modules.returnModulesRespondingTo('arcade-games').forEach(function (game_mod) {
                var pack = {};
                try {
                  pack = game_mod.respondTo('arcade-games') || {};
                } catch (_) {
                  pack = {};
                }
                var league_id = '';
                if (league) {
                  var lid = app.crypto.hash(game_mod.returnName());
                  if (league.returnLeague(lid)) {
                    league_id = lid;
                  }
                }
                var is_teaser = game_mod.teaser === true || game_mod.is_teaser === true;
                _this2.addGame({
                  game_mod: game_mod,
                  name: game_mod.name,
                  slug: game_mod.returnSlug ? game_mod.returnSlug() : game_mod.slug || '',
                  title: game_mod.returnName ? game_mod.returnName() : game_mod.name,
                  image: is_teaser ? game_mod.img || pack.image || '' : pack.image || game_mod.img || '',
                  link: game_mod.link || '',
                  league_id: league_id,
                  onClick: typeof pack.onClick === 'function' ? pack.onClick : undefined
                });
              });
              if (!app.options.arcade) {
                app.options.arcade = {};
              }
              this.show_splash = Object.prototype.hasOwnProperty.call(app.options.arcade, 'show-splash') ? app.options.arcade['show-splash'] : true;
              this.games = this.games.sort(function (a, b) {
                var _b$game_mod, _a$game_mod, _app$options$arcade;
                var b_count = ((_b$game_mod = b.game_mod) === null || _b$game_mod === void 0 ? void 0 : _b$game_mod.sort_priority) || 0;
                var a_count = ((_a$game_mod = a.game_mod) === null || _a$game_mod === void 0 ? void 0 : _a$game_mod.sort_priority) || 0;
                if (((_app$options$arcade = app.options.arcade) === null || _app$options$arcade === void 0 ? void 0 : _app$options$arcade.last_game) == b.name) {
                  return 1;
                }
                if (app.options.arcade[b.name]) {
                  b_count += 2 * app.options.arcade[b.name];
                }
                if (app.options.arcade[a.name]) {
                  a_count += 2 * app.options.arcade[a.name];
                }
                return b_count - a_count;
              });
              if (!(this.app.BROWSER == 1)) {
                _context2.n = 13;
                break;
              }
              if (this.browser_active && this.app.browser.returnURLParameter('moderator')) {
                this.sudo = true;
              }
              this.lounge_overlay = new LoungeOverlay(this.app, this, null);
              this.wizard_overlay = new GameWizard(this.app, this, null, {});
              this.add_game_overlay = new AddGameOverlay(this.app, this);
              this.game_info_overlay = new ArcadeGameInfo(this.app, this);
              this.teaser_install_overlay = new TeaserInstallOverlay(this.app, this);
              this.settings_overlay = new SettingsOverlay(this.app, this);
              this.renderIntos = this.renderIntos || {};
              this.leagueCallback = app.modules.returnFirstRespondTo('league-membership') || null;
              if (!this.app.options.games) {
                _context2.n = 12;
                break;
              }
              this.purge();
              _iterator2 = _createForOfIteratorHelper(this.app.options.games);
              _context2.p = 2;
              _iterator2.s();
            case 3:
              if ((_step2 = _iterator2.n()).done) {
                _context2.n = 9;
                break;
              }
              game = _step2.value;
              if (game.players.includes(this.publicKey) || game.accepted.includes(this.publicKey)) {
                _context2.n = 4;
                break;
              }
              return _context2.a(3, 8);
            case 4:
              if (!game.over) {
                _context2.n = 5;
                break;
              }
              return _context2.a(3, 8);
            case 5:
              if (game.players.includes(this.publicKey)) {
                _context2.n = 6;
                break;
              }
              return _context2.a(3, 8);
            case 6:
              _context2.n = 7;
              return this.createPseudoTransaction(game);
            case 7:
              game_tx = _context2.v;
              this.addInviteRecord(game_tx, game.over ? 'over' : 'active');
            case 8:
              _context2.n = 3;
              break;
            case 9:
              _context2.n = 11;
              break;
            case 10:
              _context2.p = 10;
              _t = _context2.v;
              _iterator2.e(_t);
            case 11:
              _context2.p = 11;
              _iterator2.f();
              return _context2.f(11);
            case 12:
              if ((_window = window) !== null && _window !== void 0 && _window.game) {
                _game_tx = new Transaction();
                _game_tx.deserialize_from_web(app, window.game);
                this.addInviteRecord(_game_tx);
              }
              this.renderInvites();
              setInterval(function () {
                _this2.purge();
                _this2.renderInvites();
              }, 90000);
            case 13:
              return _context2.a(2);
          }
        }, _callee2, this, [[2, 10, 11, 12]]);
      }));
      function initialize(_x2) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "renderInvites",
    value: function renderInvites() {
      if (!this.app.BROWSER) {
        return;
      }
      if (this.browser_active) {
        if (this.main) {
          this.main.renderInvites();
        }
      } else if (this.invite_manager) {
        this.invite_manager.render();
      }
    }
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var mode,
          data,
          _iterator3,
          _step3,
          mod,
          cm,
          _iterator4,
          _step4,
          _mod,
          _cm,
          _args3 = arguments;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              mode = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : null;
              data = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
              if (this.app.BROWSER) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              if (this.header) {
                _context3.n = 3;
                break;
              }
              this.header = new SaitoHeader(this.app, this);
              _context3.n = 2;
              return this.header.initialize(this.app);
            case 2:
              this.header.header_class = 'arcade';
              this.addComponent(this.header);
            case 3:
              if (!this.main) {
                this.main = new ArcadeMain(this.app, this);
                this.addComponent(this.main);
              }

              // Compatibility alias used by arcade2-era UI references
              this.ui = this.main;
              if (!this.chat_components_added) {
                _iterator3 = _createForOfIteratorHelper(this.app.modules.returnModulesRespondingTo('chat-manager'));
                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    mod = _step3.value;
                    cm = mod.respondTo('chat-manager');
                    this.addComponent(cm);
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }
                this.chat_components_added = true;
              }

              // Chat renders in the left sidebar below Home / Settings (not a nav item).
              _iterator4 = _createForOfIteratorHelper(this.app.modules.returnModulesRespondingTo('chat-manager'));
              try {
                for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                  _mod = _step4.value;
                  _cm = _mod.respondTo('chat-manager');
                  if (_cm) {
                    _cm.container = '.arcade-sidebar-left';
                    _cm.render_manager_to_screen = 1;
                  }
                }
              } catch (err) {
                _iterator4.e(err);
              } finally {
                _iterator4.f();
              }
              if (!this.browser_active) {
                _context3.n = 4;
                break;
              }
              document.body.classList.add('arcade-body');
              _context3.n = 4;
              return _superPropGet(Arcade, "render", this, 3)([]);
            case 4:
              if (mode === 'lounge_overlay') {
                if (this.lounge_overlay && (data.invite_data != null || data.game_id != null)) {
                  this.lounge_overlay.invite = data.invite_data != null ? data.invite_data : null;
                  this.lounge_overlay.game_id = data.game_id != null ? data.game_id : null;
                  this.lounge_overlay.observer_has_archive_data = data.observer_has_archive_data === true;
                  this.lounge_overlay.observer_game_module_slug = data.game_module_slug != null ? data.game_module_slug : null;
                  this.lounge_overlay.render();
                }
              }
            case 5:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "canRenderInto",
    value: function canRenderInto(qs) {
      if (qs === '.redsquare-arcade') {
        return true;
      }
      if (qs === '.arcade-sidebar') {
        return true;
      }
      return false;
    }
  }, {
    key: "renderInto",
    value: function () {
      var _renderInto = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(qs) {
        var _iterator5, _step5, comp, _t2;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              if (!(qs == '.arcade-sidebar')) {
                _context4.n = 2;
                break;
              }
              if (this.main) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              if (!this.renderIntos[qs]) {
                this.styles = ['/arcade/style.css'];
                this.renderIntos[qs] = [];
                this.renderIntos[qs].push(this.main.sidebar);
                this.attachStyleSheets();
              }
            case 2:
              if (qs == '.redsquare-arcade') {
                if (!this.renderIntos[qs]) {
                  this.styles = ['/arcade/style.css'];
                  this.renderIntos[qs] = [];
                  this.invite_manager = new InviteManager(this.app, this, qs);
                  this.invite_manager.type = 'short';
                  this.renderIntos[qs].push(this.invite_manager);
                  this.attachStyleSheets();
                }
              }
              if (!(this.renderIntos[qs] != null && this.renderIntos[qs].length > 0)) {
                _context4.n = 9;
                break;
              }
              _iterator5 = _createForOfIteratorHelper(this.renderIntos[qs]);
              _context4.p = 3;
              _iterator5.s();
            case 4:
              if ((_step5 = _iterator5.n()).done) {
                _context4.n = 6;
                break;
              }
              comp = _step5.value;
              _context4.n = 5;
              return comp.render();
            case 5:
              _context4.n = 4;
              break;
            case 6:
              _context4.n = 8;
              break;
            case 7:
              _context4.p = 7;
              _t2 = _context4.v;
              _iterator5.e(_t2);
            case 8:
              _context4.p = 8;
              _iterator5.f();
              return _context4.f(8);
            case 9:
              return _context4.a(2);
          }
        }, _callee4, this, [[3, 7, 8, 9]]);
      }));
      function renderInto(_x3) {
        return _renderInto.apply(this, arguments);
      }
      return renderInto;
    }()
  }, {
    key: "respondTo",
    value: function respondTo() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var obj = arguments.length > 1 ? arguments[1] : undefined;
      if (type === 'saito-header') {
        var x = [];
        if (!this.browser_active) {
          this.attachStyleSheets();
          x.push({
            text: 'Arcade',
            icon: this.icon || 'fas fa-gamepad',
            rank: 10,
            type: 'quicklaunch',
            callback: function callback(app, id) {
              navigateWindow("/arcade");
            },
            navigation: '/arcade'
          });
        }
        return x;
      }
      if (type === 'saito-filter-link') {
        if (obj.slug == this.returnSlug()) {
          if (!obj.url.includes('invite')) {
            return {
              info: [],
              no_photo: true
            };
          }
          return {
            info: ['title']
          };
        }
      }
      return _superPropGet(Arcade, "respondTo", this, 3)([type, obj]);
    }
  }, {
    key: "webServer",
    value: function webServer(app, expressapp, express) {
      var alternative_slug = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var uri = alternative_slug || '/' + encodeURI(this.returnSlug());
      var webdir = "".concat(__dirname, "/../../mods/").concat(this.dirname, "/web");
      var arcade_self = this;
      expressapp.use(uri, express["static"](webdir));
      expressapp.get(uri, /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(req, res) {
          var _app$options, _app$options2;
          var endpoint, protocol, host, port, reqBaseURL, game_data, updatedSocial, query_params, game, gm, game_id, html;
          return _regenerator().w(function (_context5) {
            while (1) switch (_context5.n) {
              case 0:
                endpoint = (app === null || app === void 0 || (_app$options = app.options) === null || _app$options === void 0 || (_app$options = _app$options.server) === null || _app$options === void 0 ? void 0 : _app$options.endpoint) || (app === null || app === void 0 || (_app$options2 = app.options) === null || _app$options2 === void 0 ? void 0 : _app$options2.server) || {};
                protocol = (endpoint.protocol || req.protocol || 'https').replace(/:$/, '');
                host = endpoint.host || req.hostname || req.headers.host;
                port = endpoint.port ? ":".concat(endpoint.port) : '';
                reqBaseURL = "".concat(protocol, "://").concat(host).concat(port, "/");
                game_data = null;
                updatedSocial = Object.assign({}, arcade_self.social);
                updatedSocial.url = reqBaseURL + encodeURI(arcade_self.returnSlug());
                if (Object.keys(req.query).length > 0) {
                  query_params = req.query;
                  game = (query_params === null || query_params === void 0 ? void 0 : query_params.game) || (query_params === null || query_params === void 0 ? void 0 : query_params.view_game);
                  if (typeof game === 'string') {
                    gm = app.modules.returnModuleBySlug(game) || app.modules.returnModule(game);
                    if (gm) {
                      updatedSocial.title = "Play <em>".concat(gm.returnName(), "</em> on the Saito Arcade");
                      updatedSocial.image = "".concat(reqBaseURL + gm.returnSlug(), "/img/arcade/arcade-banner-background.png");
                      updatedSocial.description = gm.description;
                      delete updatedSocial.url;
                    }
                  }
                  game_id = query_params === null || query_params === void 0 ? void 0 : query_params.game_id;
                  if (game_id != null) {
                    try {
                      game_id = decodeURIComponent(game_id);
                    } catch (_) {}
                  }
                  game_data = game_id && arcade_self.invites[game_id] ? arcade_self.invites[game_id].tx : null;
                }
                html = arcadeHome(app, arcade_self, app.build_number, updatedSocial, game_data);
                if (res.finished) {
                  _context5.n = 1;
                  break;
                }
                res.setHeader('Content-type', 'text/html');
                res.charset = 'UTF-8';
                return _context5.a(2, res.send(html));
              case 1:
                return _context5.a(2);
            }
          }, _callee5);
        }));
        return function (_x4, _x5) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  }]);
}(ModTemplate);
Object.assign(Arcade.prototype, require('./lib/invite-lifecycle'));
module.exports = Arcade;